import gql from 'graphql-tag';
import { mutation } from 'services/graphql';

export const createSignInCodeMutation = gql`
  mutation createSignInCode {
    createSignInCode {
      data {
        id
        code
        usedOn
      }
    }
  }
`;

export default mutation(createSignInCodeMutation);
